import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "short-text",
  "use": "short-text-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"short-text\"><path fill-rule=\"evenodd\" d=\"M4 9h16v2H4V9Zm0 4h10v2H4v-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol